export enum CHANNEL {
  VOICE = 'VOICE',
  SMS = 'SMS',
  RCS = 'RCS',
}

// readonly string[] (not `as const`) so `.includes()` accepts a plain string
// at both call sites, rather than narrowing to a literal union.
export const FAILED_DELIVERY_STATUSES: readonly string[] = [
  'failed',
  'undelivered',
];
